export const ADD_LAB_PATHOLOGIST = "ADD_LAB_PATHOLOGIST";
export const ADD_LAB_PATHOLOGIST_SUCCESS = "ADD_LAB_PATHOLOGIST_SUCCESS";
export const ADD_LAB_PATHOLOGIST_FAIL = "ADD_LAB_PATHOLOGIST_FAIL";

export const GET_LAB_PATHOLOGISTS = "GET_LAB_PATHOLOGISTS";
export const GET_LAB_PATHOLOGISTS_SUCCESS = "GET_LAB_PATHOLOGISTS_SUCCESS";
export const GET_LAB_PATHOLOGISTS_FAIL = "GET_LAB_PATHOLOGISTS_FAIL";

export const DELETE_LAB_PATHOLOGIST = "DELETE_LAB_PATHOLOGIST";
export const DELETE_LAB_PATHOLOGIST_SUCCESS = "DELETE_LAB_PATHOLOGIST_SUCCESS";
export const DELETE_LAB_PATHOLOGIST_FAIL = "DELETE_LAB_PATHOLOGIST_FAIL";